<template>
    <v-icon
        v-if="status == 'OLST_CANCELADA'"
        title="Activar"
        color='green'
        @click="statusOrder(false)"
    >
        mdi-check-circle-outline
    </v-icon>
    <v-icon 
        v-else
        title="Desactivar"
        color="red"
        @click="statusOrder(true)"
    >
        mdi-cancel
    </v-icon>
</template>
<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import Vue from 'vue'
export default {
    name: "StatusOrderComponent",
    props:{
        status:{
            type: String,
            default: 'OLST_CANCELADA'
        },
        idOrder: {
            type: Number,
            default: 0
        }
    },
    data:()=>({
        ...mapState(['paramAlertQuestion'])
    }),
    methods:{

        ...mapMutations(['setUrl']),

        ...mapActions(['requestApi']),

        statusOrder(status){

            Vue.swal({
                html: `¿Está seguro de ${status ? 'cancelar' : 'activar'} la orden ${this.idOrder}?`,
                 icon: 'warning',
                ...this.paramAlertQuestion
                }).then((result) => {
                if (result.isConfirmed) {
                    this.$emit('setOverlay', true)
                    this.setUrl('ordenes-laboratorio')
                    this.requestApi({
                        method:'PUT',
                        data:{
                            data:{
                                idOrder : this.idOrder,
                                status : status,
                                preview:'dnoin'
                            }
                        }
                    }).then(res=>{
                        this.$emit('setOverlay', false)
                        let order = res.data._embedded.ordenes_laboratorio[0]
                        this.$emit('updateStatusOrder',order)
                        
                    }).catch(()=>{
                        this.$emit('setOverlay', false)
                    })
                }
            })

        },

    },
    mounted(){

    }
}
</script>